import React, { useState } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import "./WhatsAppIcon.css";

const WhatsAppIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const whatsappLink = "https://wa.me/593985224301";

  return (
    <>
      <div className={`nx-wa ${isOpen ? "open" : ""}`} role="dialog" aria-modal="false" aria-label="Chat de WhatsApp">
        <div className="nx-wa__header">
          <div className="nx-wa__headerText">
            <p className="nx-wa__title">¿Listo para entrenar?</p>
            <p className="nx-wa__subtitle">Te asesoramos con rutinas, entrenamientos y cómo empezar según tu objetivo.</p>
          </div>

          <button className="nx-wa__close" onClick={() => setIsOpen(false)} aria-label="Cerrar">
            <FaTimes aria-hidden="true" />
          </button>
        </div>

        <div className="nx-wa__body">
          <a
            href={whatsappLink}
            className="nx-wa__contact"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Abrir WhatsApp NovaXFit"
          >
            <div className="nx-wa__avatar" aria-hidden="true">
              <span className="nx-wa__avatarNova">NOVA</span>
              <span className="nx-wa__avatarX">X</span>
              <span className="nx-wa__avatarFit">FIT</span>
            </div>

            <div className="nx-wa__info">
              <p className="nx-wa__name">Asesoría NovaXFit</p>
              <p className="nx-wa__meta">Respuestas rápidas</p>
            </div>

            <div className="nx-wa__cta" aria-hidden="true">
              <FaWhatsapp />
            </div>
          </a>
        </div>
      </div>

      <button
        className={`nx-fab ${isOpen ? "hidden" : ""}`}
        onClick={() => setIsOpen(true)}
        aria-label="Abrir chat de WhatsApp"
      >
        <span className="nx-fab__ring" aria-hidden="true" />
        <FaWhatsapp aria-hidden="true" />
      </button>
    </>
  );
};

export default WhatsAppIcon;